import Head from 'next/head';
import '@@/styles/swiper';
import { store, reducer } from '@@/store/secondary';
import Secondary from '@@/containers/secondary';
import HeadSeo from '@/components/head-seo';
import { getPageData } from '@/model/page';
import StoreProvider from '@/components/store-provider';

export default (props) => {
  const { pageData } = props;

  return (
    <>
      <HeadSeo pageTitle="恋与制作人 - 坠月之宴" image={pageData?.page?.share_img?.[0]?.value} />
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              document.documentElement.classList.add('pc-app');
              var isIpad = function () {
                var platform = navigator.platform === 'MacIntel' || navigator.platform === 'iPad'
                return platform && navigator.maxTouchPoints > 1
              };
              if (isIpad()) {
                var pathnameArray = window.location.pathname;
                if (pathnameArray.indexOf('/m') === -1) {
                  window.location.href =
                    window.location.href.split("#")[0]
                    + (window.location.search ? '&target=h5' : '?target=h5')
                    + window.location.hash;
                }
              }
          `,
          }}
        />
      </Head>
      <StoreProvider store={store} reducer={reducer}>
        <Secondary {...pageData} />
      </StoreProvider>
    </>
  );
};

export const getServerSideProps = async () => {
  let data = {};
  try {
    data = await getPageData();
  } catch (error) {
    throw new Error(error);
  }
  return {
    props: {
      pageData: data,
    },
  };
};
